// extracted by mini-css-extract-plugin
export default {"button":"_QuoteButton_button__RNy8W","author":"_QuoteButton_author__juhK-","author__tags":"_QuoteButton_author__tags__BXt8t"};